/**
 * Breaks long continuous words in a string for display safety.
 * Adds soft break points every `n` characters in words without spaces.
 *
 * @param text - the original input string
 * @param maxLen - max allowed word length before breaking
 * @returns formatted string with break hints
 */
export const insertWordBreaks = (text: string, maxLen: number = 30): string => {
  return text.replace(new RegExp(`\\S{${maxLen},}`, 'g'), (match) =>
    match.replace(new RegExp(`(.{${maxLen}})`, 'g'), '$1\u200B'),
  );
};
